(function(){
  function init(root){
    if (!root) return;
    var overlays = Array.prototype.slice.call(root.querySelectorAll('.ls-custom-overlay'));

    function measure(){
      overlays.forEach(function(ov){
        ov.style.setProperty('--ovh', ov.offsetHeight + 'px');
      });
    }

    // medir cuando estén las fuentes y en resize
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(measure);
    } else {
      window.addEventListener('load', measure);
    }
    window.addEventListener('resize', measure);
    measure();
  }

  // inicializa en carga normal
  document.addEventListener('DOMContentLoaded', function(){
    document.querySelectorAll('[data-ls-banner-double]').forEach(init);
  });

  // soporte editor de Shopify (al recargar una sección)
  document.addEventListener('shopify:section:load', function(e){
    var root = e.target.querySelector('[data-ls-banner-double]');
    if (root) init(root);
  });
})();


